module.exports = __webpack_public_path__ + "static/media/google_icon.be5f794c.png";